import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 3),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  title: {
    flex: 1,
  },
  actions: {
    '& > *:not(:first-child)': {
      marginLeft: theme.spacing(1),
    },
  },
}))
